<aside
  id="sidebar"
  class="sidebar fixed top-0 left-0 z-20 h-screen transition-all"
  [ngClass]="{
    'w-56': mode === 'large',
    'w-[88px]': mode === 'small'
  }"
  aria-label="Sidebar">
  <div class="h-minus-4 ml-4 rounded-b-lg border-r border-gray-300 bg-white p-4 shadow-custom-1">
    <div class="flex h-full flex-col overflow-y-auto overflow-x-hidden">
      <nav class="flex-1" aria-label="Primary">
        <ul class="space-y-2">

          <li>
            <button
              type="button"
              (click)="navigateToPage('user')"
              class="sidebar-link"
              [ngClass]="{ 'text-nside-orange-400': pageRoute === 'user' }">
              <span class="sidebar-icon">
                <lucide-icon [img]="icons.Users"></lucide-icon>
              </span>
              <span *ngIf="mode === 'large'" class="oswald-font ms-1 text-base">Users</span>
            </button>
          </li>

          <li>
            <button
              type="button"
              (click)="navigateToPage('activity')"
              class="sidebar-link"
              [ngClass]="{ 'text-nside-orange-400': pageRoute === 'activity' }">
              <span class="sidebar-icon">
                <lucide-icon [img]="icons.History"></lucide-icon>
              </span>
              <span *ngIf="mode === 'large'" class="oswald-font ms-1 text-base">Activity</span>
            </button>
          </li>

          <li>
            <button
              type="button"
              (click)="navigateToPage('admin-messages')"
              class="sidebar-link"
              [ngClass]="{ 'text-nside-orange-400': pageRoute === 'admin-messages' }">
              <span class="sidebar-icon">
                <lucide-icon [img]="icons.MessageSquareText"></lucide-icon>
              </span>
              <span *ngIf="mode === 'large'" class="oswald-font ms-1 text-base">Admin Messages</span>
            </button>
          </li>

        </ul>
      </nav>
    </div>
  </div>

  <button
    type="button"
    id="toggle-btn"
    class="absolute top-6 -right-6 cursor-pointer border-r border-gray-300 bg-white py-3 shadow-custom-1"
    (click)="$event.preventDefault(); toggle();"
    aria-label="Toggle sidebar">
    <span class="toggle-icon" [class.toggle-icon-rotated]="mode === 'small'">
      <lucide-icon [img]="icons.ChevronLeft"></lucide-icon>
    </span>
  </button>
</aside>
